import { axiosInstance } from '../../../util/axios/instance.axios'
import { PortfolioByTypeResponse, PortfolioResponse, CreatePortfolioDto, UpdatePortfolioDto } from '../model/portfolio'

export async function getPortfolio(userId?: string): Promise<PortfolioByTypeResponse> {
  const { data } = await axiosInstance.request<PortfolioByTypeResponse>({
    url: '/profile/portfolio',
    params: { userId },
  })
  
  return data
}

export async function createPortfolioItem(dto: CreatePortfolioDto): Promise<PortfolioResponse> {
  const { data } = await axiosInstance.request<PortfolioResponse>({
    url: '/profile/portfolio',
    method: 'POST',
    data: dto,
  })
  
  return data
}

export async function updateBio(dto: UpdatePortfolioDto): Promise<PortfolioResponse> {
  const { data } = await axiosInstance.request<PortfolioResponse>({
    url: '/profile/portfolio/bio',
    method: 'PUT',
    data: dto,
  })
  
  return data
}

export async function deletePortfolioItem(portfolioId: string): Promise<void> {
  await axiosInstance.request({
    url: `/profile/portfolio/${portfolioId}`,
    method: 'DELETE',
  })
}
